// Generated by genversion.
export const version = '1.0.0';
